import { CommonModule } from '@angular/common';
import { Component, inject, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService } from '../../Util/Toast/toast.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { WebMonthAttendanceService } from '../../Model/WebMonthAttendance/web-month-attendance.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-view-summary',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, LoaderComponent, DataTablesModule],
  templateUrl: './view-summary.component.html',
  styleUrl: './view-summary.component.scss'
})
export class ViewSummaryComponent {
  @Input() InputData: any;
  isDisabled: boolean = false
  activeModal = inject(NgbActiveModal);
  public User: any = null

  DesignationLoad: any[] = [];
  ShiftLoad: any[] = [];
  DutyLoad: any[] = [];
  AttendanceRemarkLoad: any[] = [];

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  TableDatas: any[] = []
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private sessionService: SessionService,
    private toast: ToastService,
    private comboload: ComboService,
    private getmonthattendance: WebMonthAttendanceService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit(): void {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  getData() {
    this.isDisabled = true;
    const data = {
      SELECTTYPE: 3,
      // MONTHNAME: this.InputData.MONTHNAME,
      // YEARNAME: this.InputData.YEARNAME,
      FROMDATE: this.InputData.FROMDATE,
      TODATE: this.InputData.TODATE,
      BRANCHID: this.InputData.BRANCHID,
      CLIENTID: this.InputData.CLIENTID,
      SITEID: this.InputData.SITEID,
      EMPTYPE: this.InputData.EMPTYPE,
      EMPCODE: this.InputData.EMPCODE,
      EMPMASTERID: this.InputData.EMPMASTERID
    }
    this.getmonthattendance.GetMonthlyAttendanceSummary(data).subscribe({
      next: (response) => {
        if (response) {
          this.TableDatas = Object.values(response.Table);
          this.isDisabled = false;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }


  Cancel() {
    this.activeModal.close()
  }
}
